/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockManageListSkuItem
 */
export interface StockManageListSkuItem {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof StockManageListSkuItem
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof StockManageListSkuItem
     */
    skuCode?: string;
    /**
     * 主图URL
     * @type {string}
     * @memberof StockManageListSkuItem
     */
    imageUrl?: string;
    /**
     * 酷澎条形码商品名称
     * @type {string}
     * @memberof StockManageListSkuItem
     */
    marketProNm?: string;
    /**
     * 酷澎选项名称
     * @type {string}
     * @memberof StockManageListSkuItem
     */
    marketOptionNm?: string;
    /**
     * 酷澎选项ID
     * @type {string}
     * @memberof StockManageListSkuItem
     */
    marketOptionId?: string;
    /**
     * 酷澎条形码编号
     * @type {string}
     * @memberof StockManageListSkuItem
     */
    marketBarcode?: string;
    /**
     * 已出库数量
     * @type {number}
     * @memberof StockManageListSkuItem
     */
    outboundQty?: number;
    /**
     * 库存数量
     * @type {number}
     * @memberof StockManageListSkuItem
     */
    stockQty?: number;
}

/**
 * Check if a given object implements the StockManageListSkuItem interface.
 */
export function instanceOfStockManageListSkuItem(value: object): value is StockManageListSkuItem {
    return true;
}

export function StockManageListSkuItemFromJSON(json: any): StockManageListSkuItem {
    return StockManageListSkuItemFromJSONTyped(json, false);
}

export function StockManageListSkuItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockManageListSkuItem {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionNm': json['marketOptionNm'] == null ? undefined : json['marketOptionNm'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'outboundQty': json['outboundQty'] == null ? undefined : json['outboundQty'],
        'stockQty': json['stockQty'] == null ? undefined : json['stockQty'],
    };
}

export function StockManageListSkuItemToJSON(json: any): StockManageListSkuItem {
    return StockManageListSkuItemToJSONTyped(json, false);
}

export function StockManageListSkuItemToJSONTyped(value?: StockManageListSkuItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'imageUrl': value['imageUrl'],
        'marketProNm': value['marketProNm'],
        'marketOptionNm': value['marketOptionNm'],
        'marketOptionId': value['marketOptionId'],
        'marketBarcode': value['marketBarcode'],
        'outboundQty': value['outboundQty'],
        'stockQty': value['stockQty'],
    };
}

